import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { UploadImage } from "../../../components/common/uploadImage/UploadImage";
import { useNotification } from "../../../context/NotificationContext";
import { BannerRoutes } from "../../../mock/bannerRoutes";
import { PLACEHOLDER_IMAGE_URL } from "../../../mock/constants";
import { URL_BANNER } from "../../../mock/page_urls";
import { createBannerSchema } from "../../../schema/bannerSchema";
import { createBanner } from "../../../services/bannerSvc";

export const BannerCreatePage = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      image: null,
      is_active: false,
      link: '',
    },
    validationSchema: createBannerSchema,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append('link', values.link);
      formData.append('is_active', values.is_active.toString());

      if (values.image) {
        formData.append('image', values.image);
      }

      try {
        const res = await createBanner(formData);
        if (res?.success) {
          showNotification("Muvaffaqiyatli", "Banner qo'shildi", "success");
          resetForm();
          setTimeout(() => {
            navigate(URL_BANNER);
          }, 1000);
        }
      } catch (e) {
        showNotification("Xatolik!", "", "error");
      }
    },
  });


  return (
    <div>
      <div className={"card"}>
        <div className="card-header">
          <h1 className="card-title">Banner qo'shish</h1>
        </div>
        <div className="card-body">
          <div id="kt_account_profile_details" className="collapse show">
            <form
              className="form"
              onSubmit={formik.handleSubmit}
              encType="multipart/form-data"
            >
              <div className="card-body p-9">
                <div className="row mb-6">
                  <label className="col-lg-4 col-form-label required fw-bold fs-6">
                    Banner ko'rinishi
                  </label>
                  <div className="col-lg-8 fv-row">
                    <div className={"rounded-4"}>
                      <img
                        data-fancybox="gallery"
                        data-caption={formik.values?.link}
                        src={formik.values.image ? URL.createObjectURL(formik.values.image) : PLACEHOLDER_IMAGE_URL}
                        className={"w-100 mt-5 mh-200px object-fit-cover rounded-4"}
                        alt={formik.values?.link} />
                    </div>
                  </div>
                </div>

                <div className="row mb-6">
                  <label className="col-lg-4 col-form-label fw-bold fs-6">
                    <span className="required">Sahifa nomi</span>
                  </label>
                  <div className="col-lg-8 fv-row">
                    <select
                      className="form-select form-select-solid form-select-lg fw-bold"
                      name="link"
                      value={formik.values.link}
                      onChange={formik.handleChange}
                    >
                      <option value="" disabled>
                        Tanlash
                      </option>
                      {
                        BannerRoutes.map((route) => (
                          <option key={route.key} value={route.key}>{route.label}</option>
                        ))
                      }
                    </select>
                    {formik.touched.link && formik.errors.link && (
                      <div className="text-danger">{formik.errors.link}</div>
                    )}
                  </div>
                </div>

                <div className="row mb-6">
                  <label className="col-lg-4 col-form-label required fw-bold fs-6">
                    Banner rasmi
                  </label>
                  <div className="col-lg-8 fv-row">
                    <UploadImage imageSizes={"avatar"} onImageUpload={(file) => {
                      if (file) {
                        formik.setFieldValue('image', file);
                      }
                    }} />

                    {formik.touched.image && formik.errors.image && (
                      <div className="text-danger">{formik.errors.image}</div>
                    )}
                  </div>
                </div>


                <div className="row mb-6 align-items-center">
                  <label className="col-lg-4 col-form-label required fw-bold fs-6">
                    Aktiv
                  </label>
                  <div className="col-lg-8 fv-row">
                    <div className="form-check form-check-solid form-switch fv-row">
                      <input
                        className="form-check-input w-45px h-30px"
                        type="checkbox"
                        id="allowmarketing"
                        checked={formik.values.is_active}
                        name={"is_active"}
                        onChange={(e) =>
                          formik.setFieldValue('is_active', e.target.checked)
                        }
                      />
                      <label className="form-check-label"></label>
                    </div>
                  </div>
                </div>

              </div>
              <div className="card-footer">
                <div className="justify-content-end d-flex gap-2">
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                    type="button"
                  >
                    Bekor qilish
                  </button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={formik.isSubmitting}
                  >
                    {
                      formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"
                    }
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};